import * as Sentry from "@sentry/react";

export function captureExceptionWithContext(err, bugDetails) {
  if (!bugDetails) Sentry.captureException(err);
  Sentry.captureException(err, { contexts: { 'Exception Details': bugDetails } });
}
